module.exports = __webpack_public_path__ + "static/media/AirgongBlack.7151f4ee.svg";